import React, { useEffect, useState, useContext } from 'react';
import { Carousel } from 'antd';
import { Link } from 'react-router-dom';
import { SucursalContext } from '../../../../context/sucursalContext';
import axios from 'axios';

const CCarruselInicio = () => {
  const { sucursal } = useContext(SucursalContext);
  const [imagenes, setImagenes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (sucursal?.suc_id) {
      fetchCarrusel();
    }
  }, [sucursal?.suc_id, isMobile]);

  const fetchCarrusel = async () => {
    try {
      setLoading(true);
      // Determinar el tipo de dispositivo según el ancho de pantalla
      const tipoDispositivo = isMobile ? 'mobile' : 'desktop';
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/carrusel/sucursal/${sucursal.suc_id}?soloActivos=true&tipoDispositivo=${tipoDispositivo}`
      );
      setImagenes(response.data || []);
    } catch (error) {
      console.error('Error al obtener carrusel:', error);
      setImagenes([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading || imagenes.length === 0) {
    return null; // No mostrar nada si no hay imágenes o está cargando
  }

  return (
    <div style={{ 
      marginBottom: isMobile ? '16px' : '24px', 
      marginTop: isMobile ? '8px' : '-20px', // Subido más arriba
      position: 'relative'
    }}>
      {/* Logo circular superpuesto parcialmente dentro del carrusel */}
      {!isMobile && (
        <Link 
          to="/" 
          style={{ 
            position: 'absolute',
            left: '24px',
            top: '-40px', // Posicionado para que esté parcialmente dentro del carrusel
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none'
          }}
        >
          <div style={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '4px solid #fff',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            transition: 'transform 0.2s',
            cursor: 'pointer',
            overflow: 'hidden'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <img 
              src="/logosuarez.png" 
              alt="Logo Suarez" 
              style={{ 
                width: '95px',
                height: '95px',
                objectFit: 'contain',
                borderRadius: '50%'
              }} 
            />
          </div>
        </Link>
      )}
      
      <Carousel
        autoplay
        autoplaySpeed={4000}
        dots={true}
        infinite={true}
        effect="fade"
        style={{
          borderRadius: '8px',
          overflow: 'visible', // Cambiado a visible para que el logo se superponga
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}
      >
        {imagenes.map((item, index) => (
          <div key={item.car_id || index}>
            <div
              style={{
                height: isMobile ? '350px' : '400px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f0f0f0',
                overflow: 'hidden'
              }}
            >
              <img
                src={item.car_imagen_url}
                alt={`Carrusel ${index + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: isMobile ? 'cover' : 'contain',
                  display: 'block',
                  // Evita suavizado por subpíxeles/transforms del Carousel (Ant Design / slick)
                  transform: 'translateZ(0)',
                  backfaceVisibility: 'hidden'
                }}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/400x200?text=Error+al+cargar';
                }}
              />
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CCarruselInicio;
